import React, {useEffect} from "react";
import { Button, Rate, Row, Col } from "antd";
import styled from "styled-components";
import {
  InstagramOutlined,
  MenuOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import backgroungImage from "../image/allimages.jpg";
// import Miximageall from "../image/Miximageall.webp";
import Miximageall from "../image/bannermiximges.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";
import BlobButton from "../resuble/BlobButton";
import AOS from "aos";
import "aos/dist/aos.css";

// Styled Components
const Container = styled.div`
  width: 100%;
  // height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LeftSection = styled.div`
  background: url(${backgroungImage}) no-repeat center center;
  background-size: cover;
  height: 95vh;
  display: flex;
  align-items: center;
  padding-left: 20%;
  position: relative;
  color: white;
  margin-top: 60px;

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
  }
`;

const OverlayContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 85%;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 40px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 28px; /* Reduce size on mobile */
  }

  @media (max-width: 480px) {
    font-size: 22px; /* Further reduce on very small screens */
  }
`;

const Subtitle = styled.p`
  font-size: 16px;
  margin: 10px 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const ShopButton = styled(Button)`
  background: #00a656;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 30px;
  border: none;
  margin-bottom: 70px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  transform: scale(1);

  &:hover {
    background: linear-gradient(
      90deg,
      rgb(3, 13, 51),
      rgb(0, 53, 55),
      #000000ba
    );
    transform: scale(1.05);
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.98);
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  position: absolute;
  left: 20px;
  bottom: 20px;
  z-index: 2;

  button {
    background: rgba(255, 255, 255, 0.3);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 35px;
    font-size: 18px;
  }
`;

const RightSection = styled.div`
  background: linear-gradient(90deg, rgb(3, 13, 51), rgb(0, 53, 55), #000000ba);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const ProductCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 50px;
  width: 100%;
  max-width: 260px;
`;

const ProductImage = styled.img`
  width: 100%;
`;

const ProductTitle = styled.h3`
  font-size: 20px;
  font-weight: 500;
  margin-top: 8px;
  font-family: auto;
`;
const Addbuttoncenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px; /* Adjust spacing */
`;

const ProductDescription = styled.p`
  font-size: 14px;
  color: gray;
`;

const Price = styled.p`
  font-size: 20px;
  font-weight: bold;
`;

// const AddToCartButton = styled(Button)`
//   background: #021734;
//   color: white;
//   width: 100%;
//   padding: 10px;
//   border-radius: 30px;
//   font-size: 16px;
//   border: none;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 5px;

//   &:hover {
//     background: linear-gradient(
//       90deg,
//       rgb(3, 13, 51),
//       rgb(0, 53, 55),
//       #000000ba
//     );
//   }
// `;
const AddToCartButton = styled.button`
  background: #021734;
  color: white;
  width: 100%;
  padding: 10px;
  border-radius: 30px;
  font-size: 13px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 150px; /* Adjust width as needed */
  cursor: pointer;
  transition: background 0.4s ease-in-out, transform 0.2s ease-in-out;

  &:hover {
    background: linear-gradient(
      90deg,
      rgb(42, 63, 91),
      rgb(0, 53, 55),
      #426391
    );
    transform: translateY(-3px); /* Makes the button "jump" slightly */
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3); /* Adds depth */
  }

  &:active {
    transform: translateY(
      0px
    ); /* Ensures the button goes back to normal when clicked */
  }
`;

const PaginationDots = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;

  span {
    width: 10px;
    height: 10px;
    background: #ddd;
    border-radius: 50%;
    margin: 0 5px;
  }

  .active {
    background: #00a656;
  }
`;

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
};
// Main Component
const Section1 = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
  }, []);

  return (
    <Container>
      <Row style={{ width: "100%", height: "100%", marginTop: "30px" }}>
        {/* Left Section - 60% */}
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={16}
          xl={16}
          xxl={16}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <LeftSection>
            <OverlayContent>
              {/* <Title>Prescription glasses and sunglasses in the latest trends</Title>
              <Subtitle>Eyeglasses with colored or tinted lenses that protect the eyes from the glare of sunlight.</Subtitle>
              <ShopButton>SHOP NOW →</ShopButton> */}
              <Slider {...sliderSettings}>
                <div>
                  <Title>
                    Investing in hotel for a luxurious and sustainable future.
                  </Title>
                  <Subtitle>Hotel Industry 🏨</Subtitle>
                </div>
                <div>
                  <Title>
                    Bridging global trade with strategic investments.
                  </Title>
                  <Subtitle>Export-Import Industry 🚢</Subtitle>
                </div>
                <div>
                  <Title>
                    Weaving innovation and sustainability into global fashion.
                  </Title>
                  <Subtitle>Textile Industry 👗</Subtitle>
                </div>
                <div>
                  <Title>
                    Building the future with smart and sustainable investments.
                  </Title>
                  <Subtitle>Real Estate Industry 🏢</Subtitle>
                </div>
              </Slider>
              {/* 
                <ShopButton>CALL NOW →</ShopButton>
              </a> */}
              <a href="tel:+919284382353">
                <BlobButton label="Call Now" />
              </a>
            </OverlayContent>

            <SocialIcons>
              <a
                href="https://wa.me/9284382353"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button icon={<WhatsAppOutlined />} />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button icon={<InstagramOutlined />} />
              </a>
              <Button icon={<MenuOutlined />} />
            </SocialIcons>
          </LeftSection>
        </Col>

        {/* Right Section - 40% */}
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={8}
          xl={8}
          xxl={8}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RightSection>
           <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 1.0 }}
            className="motion-div"
            data-aos="fade-up"
          >
            <ProductCard >
              {/* <p style={{ fontSize: "12px", color: "gray" }}>TRENDING</p> */}
              <ProductTitle>Services</ProductTitle>
              {/* <ProductDescription>Black solid titanium</ProductDescription> */}
              <ProductImage src={Miximageall} />
              <br />
              <br />
              <Rate disabled defaultValue={5} />
              <br />
              <br />
              {/* <Price>599.00 USD</Price> */}
              <Addbuttoncenter>
                <a
                  href="https://wa.me/9284382353"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AddToCartButton>
                    {/* <InstagramOutlined /> */}
                    <WhatsAppOutlined /> ADD
                  </AddToCartButton>
                </a>
              </Addbuttoncenter>
              {/* <PaginationDots>
                <span></span>
                <span className="active"></span>
                <span></span>
              </PaginationDots> */}
            </ProductCard>
            </motion.div>
          </RightSection>
        </Col>
      </Row>
    </Container>
  );
};

export default Section1;
